<template>
  <b-card no-body class="shadow flex-container grid-stack-item-content flow-window">
    <div slot="header">
      <window-header :cmp-title="capitalizeFirstLetter(mode)+' flow for '+(centreline ? centreline.ident : '')" widget-name="flow">
        <template slot="options" class="point-cloud-left">
          <!-- <b-button :disabled="loadingUls" :pressed.sync="showPrefs" size="sm" variant="dark" type="dark" class="headerSmallButton"><icon name="cogs" scale=".7"></icon></b-button> -->

        </template>
      </window-header>
    </div>
    <div id='flow-mode-grp'>
      <b-form-radio-group v-model="mode" :options="modes" class="mb-2" size="sm" >
      </b-form-radio-group>
    </div>
    <div :style="{'flex': 3, 'overflow': 'hidden'}" class="position-relative">
      <svg ref="svg" class="h-100 w-100"></svg>

      <loading-overlay :show="loading"></loading-overlay>
    </div>

    <div slot="footer">
      <b-row class="pl-1 pr-1">
        <b-col>
          <span>Parent:</span>
          <a href="#" v-if="parent" @click.prevent="loadData(undefined, parent['id'])">{{parent['ident']}}</a>
          <template v-else>not available</template>
        </b-col>
        <b-col>
          <span>Children:</span>
          <a href="#" class="ml-1" variant="link" v-for="child in children"
             @click.prevent="loadData(undefined, child['id'])" :key="child['id']">{{child['ident']}}</a>
        </b-col>
      </b-row>
    </div>

  </b-card>
</template>

<script>
  import LoadingOverlay from '../LoadingOverlay'
  import Point from 'ol/geom/Point'
  import Select from 'ol/interaction/Select'
  import VectorLayer from 'ol/layer/Vector'
  import Style from 'ol/style/Style'
  import Fill from 'ol/style/Fill'
  import Stroke from 'ol/style/Stroke'
  import * as olProj from 'ol/proj'

  import { scaleLinear, scaleTime, scaleOrdinal, schemeCategory20 } from 'd3-scale'
  import { extent } from 'd3-array'
  import { timeMonth, timeYear } from 'd3-time'
  import {timeFormat} from 'd3-time-format'
  import { axisBottom, axisLeft, tickFormat } from 'd3-axis'
  import { select } from 'd3-selection'
  import { line as d3Line } from 'd3-shape'
  import WindowHeader from '../common/WindowHeader'
  import FlowDataSettings from './FlowDataSettings'

  export default {
    components: {WindowHeader, LoadingOverlay},
    name: 'flow-data',
    data () {
      return {
        showFlowModal: false,
        loading: false,
        children: [],
        ulsTables: [],
        isFacility: false,
        drawn: false,
        facilityFlow: false,
        parent: null,
        centreline: null,
        showPrefs: false,
        loadingUls: false,
        selectInteraction: null,
        flowLayer: null,
        selectByClick: false,
        modes: [
          {
            text: 'Gas',
            value: 'gas',
          },
          {
            text: 'Water',
            value: 'water',
          }
        ],
      }
    },
    computed: {
      mode: {
        get() {
          return this.$store.getters['map/flow_mode']
        },
        set(val) {
          return this.$store.commit('map/flow_mode', val)
        }
      },
      loadingFlowInteraction: {
        get() {
          return this.$store.getters['map/loadingFlowInteraction']
        },
        set(val) {
          return this.$store.commit('map/loadingFlowInteraction', val)
        }
      },
      resized () {
        return this.$store.getters['map/widgetResizeMap']['flow']
      },
      currentProject () {
        return this.$store.getters['project/currentProject']
      },
      flow_uls_tables: {
        get() {
          return this.$store.getters['map/flow_uls_tables']
        },
        set(val) {
          return this.$store.commit('map/flow_uls_tables', val)
        }
      }
    },
    mounted () {
      this.loadingFlowInteraction = true
      // this.listUlsTables()
      this.bindClick()
    },
    destroyed () {
      this.unBindClick()
    },
    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      onClick (e) {
        if (this.loadingUls ) {
          this.$notify({
            title: 'INFO',
            text: 'ULS tables list still loading',
            type: 'info'
          })
          return
        }
        if (e.mapBrowserEvent) {
          let sg = new Point(e.mapBrowserEvent.coordinate)
          sg.transform(olProj.get('EPSG:3857'), olProj.get('EPSG:4326'))
          this.selectByClick = true
          this.loadData(sg.getCoordinates())
        }
      },
      bindClick () {

        this.flowLayer = this.$mapService.map.getLayers().getArray().filter(layer => {
          return layer.get('kegs_name') === 'v4:centreline' && (layer instanceof VectorLayer)
        })[0]

        let style = new Style({
          stroke: new Stroke({
            color: '#98FB98',
            width: 6
          }),
          fill: new Fill({
            color: 'rgba(0, 0, 255, 0.1)'
          })
        })

        this.selectInteraction = new Select({
          hitTolerance: 8,
          layers: [this.flowLayer],
          style: style

        })

        this.selectInteraction.on('select', this.onClick, this)
        this.selectInteraction.on('deselect', this.onClick, this)

        this.$mapService.addInteraction(this.selectInteraction)
        this.loadingFlowInteraction = false
      },
      unBindClick () {
        this.$mapService.removeInteraction(this.selectInteraction)
      },
      listUlsTables () {
        this.loadingUls = true
        this.$http.get('/api/projects/list-uls-tables', {
          params: {
            workpack_id: this.currentProject.workpack.id
          }
        }).then(res => {
          this.ulsTables = res.body
          let colorScale = scaleOrdinal(schemeCategory20)
          this.ulsTables.forEach((t, i) => {
            t.checked=true
            t.color=colorScale(i)
            t.label=[t.gas_forecast, t.water_forecast].join(' ')

            //quick fix for https://arrow.kegsys.com/mine/issues/53683
            if (t.gas_forecast.indexOf('davidbase') > -1 || t.gas_forecast.indexOf('davidphase') > -1) {
              if (t.gas_forecast.indexOf('fix') > -1) {
                t.color="#000000"
              } else {
                t.color="#ff0000"
              }
              t.dashed = true
            }
          })
          this.flow_uls_tables = this.ulsTables.map(t=> t.id).join(',')
          this.bindClick()
          this.loadingUls = false
        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not load ULS tables',
            type: 'error'
          })
          this.loadingUls = false
        })
      },
      loadData (coordinate, centreline_id) {
        this.loading = true
        this.$http.get('/api/projects/getFlowCentrelineData', {
          params: {
            coordinate: coordinate ? coordinate.join(',') : undefined,
            workpack_id: this.currentProject.workpack.id,
            centreline_id: centreline_id,
            table_ids: this.flow_uls_tables,
            mode: this.mode
          }
        })
          .then(res => {
            this.children = res.body['children']
            this.isFacility = res.body['is_facility']
            this.parent = res.body['parent']
            this.centreline = res.body['centreline']
            this.facilityFlow = res.body['facility_flow'] || {}

            if (!this.selectByClick) {
              this.flowLayer.getSource().getFeatures().forEach(f => {
                if (f && f.get('id') && f.get('id') === this.centreline['id']) {
                  this.selectInteraction.getFeatures().clear()
                  this.selectInteraction.getFeatures().push(f)
                  this.selectInteraction.dispatchEvent({
                     type: 'select',
                     selected: [f],
                     deselected: []
                  });
                }
              })
            }
            this.loading = false
            this.selectByClick = false
            this.buildChart()
          }, res => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not load flow data.',
              type: 'error'
            })
            this.loading = false
          })
      },
      buildChart () {
        this.drawn = true
        let svg = select(this.$refs.svg)
        svg.selectAll('*').remove()
        let bbox = this.$refs.svg.getBoundingClientRect()
        let paddingLeft = 50
        let paddingRight = 50
        let paddingBottom = 50
        let paddingTop = 50
        let width = bbox.width
        let height = bbox.height
        let minFlow = Infinity
        let maxFlow = 0
        let dates = []


        let fm = d => {
          return {
            'val': parseFloat(d['val']),
            'by_date': new Date(d['by_date'])
          }
        }

        let last = this.centreline['flow'].reverse().findIndex(v => parseFloat(v['val']) > 0) - 1
        let first = this.centreline['flow'].reverse().findIndex(v => parseFloat(v['val']) > 0) - 1
        this.centreline['flow'] = this.centreline['flow'].slice(first, this.centreline['flow'].length - last)
        /*START LINES*/
        let e = extent(this.centreline['flow'].map(v => parseFloat(v['val'])))
        if (e[0] < minFlow) {
          minFlow = e[0]
        }

        if (e[1] > maxFlow) {
          maxFlow = e[1]
        }

        dates = this.centreline['flow'].map(d => new Date(d['by_date']))
        maxFlow = Math.max(maxFlow, parseFloat(this.centreline['max_flowrate']))
        let scaleX = scaleTime().domain(extent(dates)).range([paddingLeft, width - paddingRight])
        let scaleY = scaleLinear().domain([minFlow, maxFlow + 1]).range([height - paddingTop, paddingBottom])

        let line = d3Line()
          .x(function (d, i) {return scaleX(d['by_date']) })
          .y(function (d) { return scaleY(d['val']) })

        // uls_tables.forEach(tid => {

          // let flows = []
          //
          // flows.push(this.centreline['flow'].filter(d => d['flow_type'] === 'gas').map(fm))
          // flows.push(this.facilityFlow.filter(d => d['flow_type'] === 'gas').map(fm))


          // this.children.forEach(child => {
          //   flows.push(child['flow'].filter(d => d['flow_type'] === 'gas').map(fm))
          // })
          // flows.forEach(f => {
          //   let e = extent(f.map(v => v['val']))
          //   if (e[0] < minFlow) {
          //     minFlow = e[0]
          //   }
          //
          //   if (e[1] > maxFlow) {
          //     maxFlow = e[1]
          //   }
          // })



          let me = this
          /*svg.selectAll(`g.gline${tid}`)
          // .attr('transform', 'translate(' + paddingLeft + ',' + startY + ')')
            .data(this.centreline['flow'][tid].map(fm))
            .enter()
            .append('g')
            .attr('class', `.gline${tid}`)
            .append('path')
            .attr('fill', 'none')
            .attr('stroke', me.ulsTables.filter(t => t.id === parseInt(tid))[0].color)
            .attr('d', line)
        })*/

        svg
          // .attr('transform', 'translate(' + paddingLeft + ',' + startY + ')')
            .append('path')
            .datum(this.centreline['flow'].map(fm))
            .attr('class', `.gline${'flow'}`)
            .attr('fill', 'none')
            .attr('stroke', '#b4ff46')
            .attr('stroke-width', '3')
            // .attr('stroke-dasharray', me.ulsTables.filter(t => t.id === parseInt(tid))[0].dashed ? 4 : 0)
            .attr('d', line)
        // })


        /*END LINES*/

        svg.append('g')
          .attr('class', 'xaxis')
          .attr('transform', 'translate(0,' + (height - paddingBottom) + ')')
          .call(axisBottom().scale(scaleX).ticks(timeMonth, 3)
          .tickFormat(timeFormat('%b %Y')))

        svg.selectAll('.xaxis text')  // select all the text elements for the xaxis
          .attr('transform', function (d) {
            return 'translate(' + this.getBBox().height * -2 + ',' + this.getBBox().height + ')rotate(-45)'
          })

        svg.append('g')
          .attr('class', 'yaxis')
          .attr('transform', 'translate(' + paddingLeft + ', 0)')
          .call(axisLeft().scale(scaleY))

        svg.append('line')
          .attr('class', 'mf-line')
          .attr('x1', paddingLeft)
          .attr('x2', width - paddingRight)
          .attr('y1', scaleY(this.centreline['max_flowrate']))
          .attr('y2', scaleY(this.centreline['max_flowrate']))

        if (!this.isFacility) {
          svg.append('line')
            .attr('class', 'mf-line')
            .attr('x1', paddingLeft)
            .attr('x2', width - paddingRight)
            .attr('y1', scaleY(parseFloat(this.centreline['min_flowrate'])))
            .attr('y2', scaleY(parseFloat(this.centreline['min_flowrate'])))

          svg.append('g')
            .attr('transform', 'translate(' + (width / 2) + ', ' + (scaleY(this.centreline['max_flowrate']) - 3) + ')')
            .append('text')
            .attr('class', 'mf-size-label')
            .text(this.centreline['size'])

          svg.append('g')
            .attr('transform', 'translate(' + (width / 2) + ', ' + (scaleY(parseFloat(this.centreline['min_flowrate'])) - 3) + ')')
            .append('text')
            .attr('class', 'mf-size-label')
            .text(this.centreline['size'])
        }

      }
    },
    watch: {
      resized () {
        if (this.drawn) {
          this.buildChart()
        }
      },
      flow_uls_tables (val) {
        if (this.drawn) {
          this.buildChart()
        }
      },
      mode () {
        this.loadData(undefined, this.centreline['id'])
      },
      showPrefs (val) {
        if (val) {
          let opts = {
            available: true,
            enabled: true,
            clazz: FlowDataSettings,
            w: 3,
            h: 4,
            x: 3,
            y: 0,
            propsData: {
              uls_tables: this.ulsTables
            },
            destroyable: true
          }

          this.$store.commit('cmp/update', {
            cmp: 'flow-options',
            payload: opts
          })
        }
      }
    }
  }
</script>

<style lang="scss">
  .flow-chart-container {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .mf-line {
    stroke: #868e96;
    shape-rendering: crispEdges;
    stroke-width: 1;
    stroke-dasharray: 5, 5;
  }

  .mf-size-label {
    color: #868e96;
    font-style: italic;
  }
  .xaxis text {
    font-size: 12px;
  }
  .yaxis text {
    font-size: 12px;
  }
  #flow-mode-grp {
    padding: 0 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/map/FlowData.vue